import controller from './form-input-controller';
import template from './form-input.html';

const FormInputComponent = {
    bindings: {
        field: '<',
        inputType: '<',
        isEditMode: '<',
        ngModel: '='
    },
    controller,
    template
};

export default FormInputComponent;



// WEBPACK FOOTER //
// ./app/components/enter-virtual-data/form-input/form-input-component.js